export default __webpack_public_path__ + "ef2119221c9aee9d39dd25b8fd1b2e4e.png";